import Swal, { SweetAlertOptions } from 'sweetalert2';

export function Confirmable(options?: SweetAlertOptions): MethodDecorator {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    const config: SweetAlertOptions = {
      title: 'Are you sure?',
      text: 'Do you want to perform this action?',
      showDenyButton: true,
      confirmButtonColor: '#40c057',
      confirmButtonText: 'Yes, do it!',
      denyButtonText: 'No, cancel!',
      icon: 'question'
    };
    if (options) {
      Object.assign(config, options);
    }

    const updatedDescriptor: PropertyDescriptor = {
      ...descriptor,
      value: async function (...args: any[]) {
        const result = await Swal.fire(config);
        if (result.isConfirmed) {
          const originalResult = originalMethod.apply(this, args);
          return originalResult;
        }
      }
    };

    Object.defineProperty(target, key, updatedDescriptor);
    return updatedDescriptor;
  };
}
export function ConfirmableUserEmail(options?: SweetAlertOptions): MethodDecorator {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    const config: SweetAlertOptions = {
      title: 'User Created',
      text: 'Verification email has been sent to registered email address.',
      showDenyButton: false,
      confirmButtonColor: '#40c057',
      confirmButtonText: 'Okay', 
      icon: 'success',
      footer: '<p style="color:Tomato;"> <i> Note: In case you dont get the email, please make sure to check your spam folder.</i></p>' 
    };
    if (options) {
      Object.assign(config, options);
    }

    const updatedDescriptor: PropertyDescriptor = {
      ...descriptor,
      value: async function (...args: any[]) {
        const result : any = await Swal.fire(config);
        // localStorage.setItem('moduleChanged', JSON.stringify(result) );
        // const originalResult = originalMethod.apply(this, args);
        // return originalResult;
        //   if (result.isConfirmed) {
        // }
      }
    };

    Object.defineProperty(target, key, updatedDescriptor);
    return updatedDescriptor;
  };
}